"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Converter = /** @class */ (function () {
    function Converter(_a) {
        var EntityConstructor = _a.EntityConstructor, mapping = _a.mapping;
        this.EntityConstructor = EntityConstructor;
        this.mapping = mapping;
    }
    /**
     * Convert Entity|ValueObject to JSON format
     */
    Converter.prototype.toJSON = function (entity) {
        var _this = this;
        var json = {};
        Object.keys(entity.props).forEach(function (key) {
            var mappingItem = _this.mapping[key];
            if (mappingItem instanceof Converter) {
                json[key] = mappingItem.toJSON(entity.props[key]);
            }
            else {
                json[key] = mappingItem[0](entity.props[key]);
            }
        });
        return json;
    };
    /**
     * Convert Props to JSON
     */
    Converter.prototype.propsToJSON = function (props) {
        var _this = this;
        var json = {};
        Object.keys(props).forEach(function (key) {
            var mappingItem = _this.mapping[key];
            if (mappingItem instanceof Converter) {
                json[key] = mappingItem.toJSON(props[key]);
            }
            else {
                json[key] = mappingItem[0](props[key]);
            }
        });
        return json;
    };
    /**
     * Convert JSON to Props
     */
    Converter.prototype.JSONToProps = function (json) {
        var _this = this;
        var props = {};
        Object.keys(json).forEach(function (key) {
            var mappingItem = _this.mapping[key];
            var jsonItem = json[key];
            if (mappingItem instanceof Converter) {
                props[key] = mappingItem.JSONToProps(jsonItem);
            }
            else {
                props[key] = mappingItem[1](jsonItem);
            }
        });
        return props;
    };
    /**
     * Convert JSON to Entity|ValueObject
     */
    Converter.prototype.fromJSON = function (json) {
        var _this = this;
        var props = {};
        Object.keys(json).forEach(function (key) {
            var mappingItem = _this.mapping[key];
            var jsonItem = json[key];
            if (mappingItem instanceof Converter) {
                props[key] = mappingItem.fromJSON(jsonItem);
            }
            else {
                props[key] = mappingItem[1](jsonItem);
            }
        });
        return new this.EntityConstructor(props);
    };
    return Converter;
}());
exports.Converter = Converter;
/**
 * Create convert that convert JSON <-> Props <-> Entity.
 * Limitation: Convert can be possible one for one converting.
 * @param EntityConstructor
 * @param mappingPropsAndJSON
 */
exports.createConverter = function (EntityConstructor, 
// Props[P] => Entity or ValueObject
// JSON[P] => json property
// Props[P].props => Entity's props or ValueObject's props
mappingPropsAndJSON) {
    return new Converter({
        EntityConstructor: EntityConstructor,
        mapping: mappingPropsAndJSON
    });
};
//# sourceMappingURL=Converter.js.map